import { Component } from "@angular/core";

@Component({
  selector: "y-global-toast",
  templateUrl: "./global-toast.component.html",
  standalone: false,
})
export class GlobalToastComponent {}
